import { normalizeButtons } from "@zgame/protocol";
export const DEFAULT_MAPPING = {
    UP: "UP",
    DOWN: "DOWN",
    LEFT: "LEFT",
    RIGHT: "RIGHT",
    A: "A",
    B: "B",
    X: "X",
    Y: "Y",
    L: "L",
    R: "R",
    START: "START",
    SELECT: "SELECT",
};
/** 按游戏 manifest 覆盖的按键映射。 */
export function applyMapping(state, mapping = DEFAULT_MAPPING) {
    const out = {};
    for (const [from, to] of Object.entries(mapping)) {
        const value = state[from];
        if (value !== undefined)
            out[to] = value;
    }
    return normalizeButtons(out);
}
/** 聚合多个输入源（键盘 + 手柄 + 触屏）为一个状态。 */
export class InputAggregator {
    #sources;
    #unsubs = [];
    #listeners = new Set();
    constructor(sources) {
        this.#sources = sources;
    }
    start() {
        for (const s of this.#sources)
            s.start?.();
        for (const s of this.#sources) {
            const unsub = s.onChange((_c, _a) => this.#notify());
            this.#unsubs.push(unsub);
        }
    }
    stop() {
        for (const fn of this.#unsubs)
            fn();
        this.#unsubs = [];
        for (const s of this.#sources)
            s.stop?.();
    }
    onChange(cb) {
        this.#listeners.add(cb);
        return () => this.#listeners.delete(cb);
    }
    snapshot() {
        const merged = {};
        for (const s of this.#sources) {
            Object.assign(merged, s.snapshot());
        }
        return normalizeButtons(merged);
    }
    #notify() {
        const all = this.snapshot();
        for (const cb of this.#listeners)
            cb(all);
    }
}
//# sourceMappingURL=mapping.js.map